import React, { useState, useEffect } from "react";
import "./Withdraw.css";
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFileUpload } from "react-icons/fa";
import Header from "../header/Header";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import Appconfig from "../../config/config";
import Helper from "../../helper";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Input, Table, Image, Button, Switch, Tooltip } from "antd";
import { getPaymentMethods } from "../../redux/slice/paymentMethod/paymentMethodSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const AddWithdrawMethod = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userInfo = Helper();
  const userInfos = useSelector((state) => state.paymentMethods); // Use selector to access state
  const paymentMethod = userInfos?.paymentMethods || [];
  console.log("paymentMethod", paymentMethod);

  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  let balanceWithExp = balance - Math.abs(exposure);

  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("new-account"); // Set default to 'new-account'
  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [buttonText, setButtonText] = useState("Submit"); // State for button text
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [showAddAccountForm, setAddAccountForm] = useState(false);
  const [showBankForm, setShowBankForm] = useState("");
  const [showUpiForm, setShowUpiForm] = useState("");
  const [showEditPopup, setShowEditPopup] = useState(false); // State to handle Edit form popup visibility
  const [editingSection, setEditingSection] = useState(null); // Track which section is being edited
  const [showPreviousAccount, setShowPreviousAccount] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [bankName, setBankName] = useState("");
  const [showWithdrawHistory, setShowWithdrawHistory] = useState(true);

  const [upiId, setUpiId] = useState("");
  const [upiHolder, setUpiHolder] = useState("");
  const [button, setButton] = useState(false);

  const [AcNumValidationError, setAcNumValidationError] = useState(
    "Please enter account number",
  );
  const [AcHolderValidationError, setAcHolderValidationError] = useState(
    "Please enter account holder name",
  );
  const [IfscValidationError, setIfscValidationError] = useState(
    "Please enter ifsc code",
  );
  const [BankValidationError, setBankValidationError] = useState(
    "Please enter bank name",
  );
  const [UPIValidationError, setUPIValidationError] =
    useState("Please enter id");
  const [HolderValidationError, setHolderValidationError] = useState(
    "Please enter holder name",
  );

  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isSavingMethod, setIsSavingMethod] = useState(false);

  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    name: "Example",
    accountNumber: "12345678xxxx",
    ifscCode: "SBIN000002",
    bankName: "State Bank of India",
  });

  const [UPIDetails, setUPIDetails] = useState({
    upi_id: "1234fgd",
    phoneNumber: "12345678xxxx",
  });

  // Handle changes in the Bank input fields during editing
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({
      ...bankDetails,
      [name]: value,
    });
  };

  useEffect(() => {
    getUserPaymentMethods();
  }, []);

  const getUserPaymentMethods = () => {
    dispatch(
      getPaymentMethods({
        site_code: Appconfig.sitecodes,
        user_id: userInfo?._id,
      }),
    );
  };

  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo]);

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance);
          setExposure(response.data.resultData?.exposure);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Handle changes in the UPI input fields during editing
  const handleUPIInputChange = (e) => {
    const { name, value } = e.target;
    setUPIDetails({
      ...UPIDetails,
      [name]: value,
    });
  };

  const toggleEditPopup = (section) => {
    setEditingSection(section); // Set the section (either "bank" or "upi")
    setShowEditPopup(!showEditPopup); // Toggle the popup
  };

  function deletePaymentDetails(id) {
    var data = JSON.stringify({
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}paymentMethod/deleteType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getUserPaymentMethods();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handlePreviousAccount = () => {
    setShowPreviousAccount(!showPreviousAccount);
    setShowPaymentMethods(false);
  };

  // Function to handle button click
  const handleButtonClick = (value) => {
    setInputValue(value);
  };

  // Function to handle payment option click
  const handleClick = (option) => {
    setSelectedOption(selectedOption === option ? null : option); // Toggle between opening/closing
  };

  const handlePaymentMethod = () => {
    setShowPaymentMethods(!showPaymentMethods);
    setShowPreviousAccount(false);

    // Hide all forms using an array of form setters
    [setShowUpiForm].forEach((setter) => setter(false));
  };

  const handleFormToggle = (form) => {
    setUpiId("");
    setUpiHolder("");
    setShowUpiForm(form);
  };

  // Button values
  const buttonValues = [500, 1000, 1500, 2000, 2500, 3000];

  const tickMark = (
    <svg
      width="58"
      height="45"
      viewBox="0 0 58 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M19.11 44.64L.27 25.81l5.66-5.66 13.18 13.18L52.07.38l5.65 5.65"
      />
    </svg>
  );

  const checkValidation = () => {
    if (!showUpiForm) {
      toast.error("Please select a payment method.", {
        autoClose: 2000,
      });

      return false;
    }

    if (!isTermsChecked) {
      toast.error("Please accept the payment and withdrawal policy.", {
        autoClose: 2000,
      });

      return false;
    }

    if (showUpiForm === "Bank") {
      if (!accountNumber.trim()) {
        toast.error("Please enter account number.", {
          autoClose: 2000,
        });
        return false;
      }

      if (!accountHolder.trim()) {
        toast.error("Please enter account holder name.", {
          autoClose: 2000,
        });
        return false;
      }

      if (!ifscCode.trim()) {
        toast.error("Please enter IFSC code.", {
          autoClose: 2000,
        });
        return false;
      }

      if (!bankName.trim()) {
        toast.error("Please enter bank name.", {
          autoClose: 2000,
        });
        return false;
      }

      return true;
    }

    if (!upiId.trim()) {
      toast.error(`Please enter ${showUpiForm} ID or number.`, {
        autoClose: 2000,
      });
      return false;
    }

    if (!upiHolder.trim()) {
      toast.error("Please enter holder name.", {
        autoClose: 2000,
      });
      return false;
    }

    return true;
  };

  // Handle submit click and toggle button text & style
  const handleSubmitClick = async (event) => {
    event.preventDefault();

    if (!userInfo?._id) {
      toast.error("User information is unavailable.", {
        autoClose: 2000,
      });
      return;
    }

    if (!checkValidation()) {
      return;
    }

    const paymentPayload = {
      master_id: userInfo?.master_id,
      user_id: userInfo?._id,
      site_code: userInfo?.site_code || Appconfig.sitecodes,

      type: showUpiForm,

      bank_name: showUpiForm === "Bank" ? bankName.trim() : "",

      account_no: showUpiForm === "Bank" ? accountNumber.trim() : "",

      account_holder_name: showUpiForm === "Bank" ? accountHolder.trim() : "",

      ifsc_code: showUpiForm === "Bank" ? ifscCode.trim().toUpperCase() : "",

      holder_name: showUpiForm !== "Bank" ? upiHolder.trim() : "",

      upi_id: showUpiForm !== "Bank" ? upiId.trim() : "",
    };

    setIsSavingMethod(true);
    setIsSubmitted(true);
    setButtonText("Saving...");

    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}withdraw/addWithdrawPaymentMethod`,
        paymentPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.data?.result) {
        throw new Error(
          response.data?.resultMessage || "Unable to add payment method.",
        );
      }

      toast.success(
        response.data?.resultMessage || "Payment method added successfully.",
        {
          autoClose: 2000,
        },
      );

      /*
       * Newly added method immediately table mein
       * show hoga.
       */
      await dispatch(
        getPaymentMethods({
          site_code: Appconfig.sitecodes,
          user_id: userInfo?._id,
        }),
      );

      setShowFormModal(false);
      setShowUpiForm("");
      setSelectedOption(null);

      setIfscCode("");
      setAccountNumber("");
      setAccountHolder("");
      setBankName("");
      setUpiId("");
      setUpiHolder("");
      setIsTermsChecked(false);
      setButtonText("Submit");
    } catch (error) {
      console.error("Add withdrawal payment method failed:", error);

      toast.error(
        error?.response?.data?.resultMessage ||
          error.message ||
          "Unable to add payment method.",
        {
          autoClose: 2000,
        },
      );

      setButtonText("Submit");
    } finally {
      setIsSavingMethod(false);
      setIsSubmitted(false);
    }
  };

  function cancelWithdrawRequest(record, status) {
    setButton(true);
    var data = JSON.stringify({
      record: record,
      status: status,
      master_details: userInfo,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/confirmWithdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getWithdrawHistory();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setButton(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // const methodColumns = [
  //   {
  //     title: "Type",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.type}</span>,
  //   },
  //   {
  //     title: "Holder Name",
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className="">
  //         {record?.type == "Bank" ? record?.accountHolder : record?.holderName}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "UPI ID",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.upiId}</span>,
  //   },
  //   {
  //     title: "Account No.",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.accountNo}</span>,
  //   },
  //   {
  //     title: "UPI ID",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.upiId}</span>,
  //   },
  //   {
  //     title: "IFSC Code",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.ifscCode}</span>,
  //   },
  //   {
  //     title: "Bank Name",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.bankName}</span>,
  //   },
  //   {
  //     title: "More",
  //     sorter: true,
  //     render: (_, record) => (
  //       <div className="">
  //         <button
  //           disabled={button}
  //           onClick={() => deleteWithdrawMethod(record?._id)}
  //           className="custom-button"
  //         >
  //           <span>Delete</span>
  //         </button>
  //         <button
  //           disabled={button}
  //           onClick={() =>
  //             statusWithdrawMethod(
  //               record?._id,
  //               record?.status == "Active" ? "Inactive" : "Active"
  //             )
  //           }
  //           className="custom-button"
  //           style={{ color: record?.status == "Active" ? "green" : "red" }}
  //         >
  //           <span>{record?.status}</span>
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  const methodColumns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 74,
      align: "center",

      render: (value) => (
        <span className="withdraw-method-type">{value || "—"}</span>
      ),
    },

    {
      title: "Payment Details",
      key: "paymentDetails",

      render: (_, record) => {
        const isBank = record?.type === "Bank";

        if (isBank) {
          return (
            <dl className="withdraw-payment-details">
              <div className="withdraw-payment-detail-row">
                <dt>Account Name</dt>
                <dd>{record?.accountHolder || "—"}</dd>
              </div>

              <div className="withdraw-payment-detail-row">
                <dt>Account No.</dt>
                <dd>{record?.accountNo || "—"}</dd>
              </div>

              <div className="withdraw-payment-detail-row">
                <dt>Bank</dt>
                <dd>{record?.bankName || "—"}</dd>
              </div>

              <div className="withdraw-payment-detail-row">
                <dt>IFSC</dt>
                <dd>{record?.ifscCode || "—"}</dd>
              </div>
            </dl>
          );
        }

        return (
          <dl className="withdraw-payment-details">
            <div className="withdraw-payment-detail-row">
              <dt>Holder</dt>
              <dd>{record?.holderName || "—"}</dd>
            </div>

            <div className="withdraw-payment-detail-row">
              <dt>
                {record?.type === "UPI"
                  ? "UPI ID"
                  : `${record?.type || "Payment"} ID`}
              </dt>

              <dd>{record?.upiId || "—"}</dd>
            </div>
          </dl>
        );
      },
    },

    {
      title: "Action",
      key: "actions",
      width: 104,
      align: "center",

      render: (_, record) => (
        <div className="withdraw-method-actions">
          <Tooltip title="Delete method">
            <button
              type="button"
              disabled={button}
              onClick={() => deleteWithdrawMethod(record?._id)}
              className="withdraw-method-delete"
              aria-label="Delete payment method"
            >
              <DeleteOutlined />
            </button>
          </Tooltip>

          <Tooltip
            title={
              record?.status === "Active"
                ? "Deactivate method"
                : "Activate method"
            }
          >
            <Switch
              size="small"
              checked={record?.status === "Active"}
              loading={button}
              onChange={(checked) =>
                statusWithdrawMethod(
                  record?._id,
                  checked ? "Active" : "Inactive",
                )
              }
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const getWithdrawHistory = () => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/getWithdrawHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setWithdrawHistory(response.data.resultData);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const deleteWithdrawMethod = (id) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/deleteWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            }),
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const statusWithdrawMethod = (id, status) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
      status: status,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/statusWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            }),
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function selectPaymentDetail(detail) {
    setBankName(detail?.bankName);
    setAccountNumber(detail?.accountNo);
    setAccountHolder(detail?.accountHolder);
    setIfscCode(detail?.ifscCode);
    setUpiId(detail?.upiId);
    setUpiHolder(detail?.holderName);
    setShowUpiForm(detail?.type);
  }

  useEffect(() => {
    getWithdrawHistory();
  }, []);

  // useEffect(() => {
  //   document.body.style.overflow = selectedOption === "new-account" ? "hidden" : "auto";
  // }, [selectedOption]);

  const handlePaymentMethodSelect = (method) => {
    setShowUpiForm(method);
    setSelectedOption("new-account");

    /*
     * Previous method ki values new form mein
     * accidentally show nahi hongi.
     */
    setIfscCode("");
    setAccountNumber("");
    setAccountHolder("");
    setBankName("");
    setUpiId("");
    setUpiHolder("");
    setIsTermsChecked(false);
    setIsSubmitted(false);
    setButtonText("Submit");

    /*
     * Payment method select karte hi modal open hoga.
     */
    setShowFormModal(true);
  };

  const closePaymentMethodModal = () => {
    if (isSavingMethod) {
      return;
    }

    setShowFormModal(false);
  };

  useEffect(() => {
    document.body.style.overflow = showFormModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showFormModal]);

  return (
    <>
      <main className="withdraw-page add-withdraw-method-page">
        {/* <Header /> */}
        {/* <ExposureHeader /> */}
        {/* <div>
        <nav className="breadcrumb-nav" aria-label="Breadcrumb">
          <a title="LotusPlus365-Home" className="home-link" href="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 576 512"
              fill="var(--icon-color-brand-secondary1)"
            >
              <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path>
            </svg>{" "}
          </a>
          <div className="breadcrumb-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="var(--icon-color-tertiary2)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M9 6l6 6l-6 6"></path>
            </svg>
            <a
              className="breadcrumb-back-link"
              aria-current="page"
              title="LotusPlus365-Withdraw"
              href="/withdraw"
            >
              Back
            </a>
          </div>
        </nav>
      </div> */}

        {/* <div className="lg:flex sticky top-0 app-bg font-lato-bold w-full justify-between items-center lg:pt-0">
        <div>
          <nav
            className="flex items-center justify-center w-max space-x-1 text-sm text-white/80 p-2"
            aria-label="Breadcrumb"
          >
            <a title="LotusPlus365-Home" className="flex items-center" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 576 512"
                fill="var(--icon-color-brand-secondary1)"
              >
                <path
                  d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                ></path>
              </svg>
            </a>
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="var(--icon-color-tertiary2)"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
              <a
                className="ml-1 text-lg transition-all ease-in-out duration-300 text-text_brand_primary font-semibold hover:underline"
                aria-current="page"
                title="LotusPlus365-Withdraw"
                href="/withdraw"
              >
                Back
              </a>
            </div>
          </nav>
        </div>
      </div> */}

        <nav
          className="withdraw-breadcrumb"
          aria-label="Withdraw method navigation"
        >
          <button
            type="button"
            className="withdraw-home-link"
            onClick={() => navigate("/withdraw")}
            aria-label="Go back to withdraw"
          >
            <i className="fas fa-home" aria-hidden="true" />
          </button>

          <span className="withdraw-breadcrumb-arrow" aria-hidden="true">
            <i className="fas fa-chevron-right" />
          </span>

          <span className="withdraw-breadcrumb-title">Add Withdraw Method</span>
        </nav>

        <section className="withdraw-card add-withdraw-card">
          <header className="add-withdraw-heading">
            <h2 className="add-withdraw-title">Add New Payment Method</h2>

            <p className="add-withdraw-subtitle">
              Select a payment method and enter your account details.
            </p>
          </header>

          {/* <div className="payment-method-section">
          <h3 className="section-title">Select Payment Method</h3>
          <div className="payment-method-grid">
            {Appconfig.withdraw_account_type?.map((type) => (
              <button
                key={type}
                onClick={() => handlePaymentMethodSelect(type)}
                className={`payment-button ${
                  type === showUpiForm ? "selected" : ""
                }`}
              >
                <img
                  src={`../Images/${
                    type === "Bank"
                      ? "bank.png"
                      : type === "Gpay"
                      ? "icons8-google-pay.svg"
                      : type === "UPI"
                      ? "icons8-bhim-50.svg"
                      : type === "Phonepe"
                      ? "icons8-phone-pe.svg"
                      : "icons8-paytm.svg"
                  }`}
                  alt={type}
                  className="payment-icon"
                />
                <span className="payment-label">{type}</span>
              </button>
            ))}
          </div>
        </div> */}
          <section className="withdraw-methods-section add-withdraw-methods">
            <h3 className="withdraw-section-title">Select Payment Method</h3>

            <div className="withdraw-method-grid add-withdraw-method-grid">
              {(Appconfig.withdraw_account_type?.length
                ? Appconfig.withdraw_account_type
                : ["Bank", "UPI"]
              ).map((method) => {
                const iconName =
                  method === "Bank"
                    ? "bank.png"
                    : method === "Gpay"
                      ? "icons8-google-pay.svg"
                      : method === "Phonepe"
                        ? "icons8-phone-pe.svg"
                        : method === "UPI"
                          ? "icons8-bhim-50.svg"
                          : "icons8-paytm.svg";

                return (
                  <Tooltip key={method} title={`Add ${method} method`}>
                    <button
                      type="button"
                      className={[
                        "withdraw-method-icon-button",
                        showUpiForm === method
                          ? "withdraw-method-icon-button-selected"
                          : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      onClick={() => handlePaymentMethodSelect(method)}
                      aria-label={`Add ${method} payment method`}
                      title={method}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/Images/${iconName}`}
                        alt=""
                        aria-hidden="true"
                        className="withdraw-method-compact-icon"
                      />

                      <span className="withdraw-method-icon-label">
                        {method}
                      </span>
                    </button>
                  </Tooltip>
                );
              })}
            </div>
          </section>

          {showUpiForm && showFormModal && (
            <div
              className="add-withdraw-modal-backdrop"
              onClick={closePaymentMethodModal}
            >
              <div
                className="add-withdraw-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="payment-method-modal-title"
                onClick={(event) => event.stopPropagation()}
              >
                <header className="add-withdraw-modal-header">
                  <div>
                    <span className="add-withdraw-modal-eyebrow">
                      Payment details
                    </span>

                    <h3 id="payment-method-modal-title">
                      Add {showUpiForm} Method
                    </h3>
                  </div>

                  <button
                    type="button"
                    onClick={closePaymentMethodModal}
                    className="add-withdraw-modal-close"
                    disabled={isSavingMethod}
                    aria-label="Close payment method form"
                  >
                    &times;
                  </button>
                </header>

                <form
                  onSubmit={handleSubmitClick}
                  className="add-withdraw-form"
                >
                  {showUpiForm === "Bank" ? (
                    <div className="add-withdraw-fields">
                      <label className="add-withdraw-field">
                        <span>Account holder name</span>

                        <input
                          type="text"
                          value={accountHolder}
                          onChange={(event) =>
                            setAccountHolder(event.target.value)
                          }
                          placeholder="Enter account holder name"
                          className="add-withdraw-input"
                          autoComplete="name"
                        />
                      </label>

                      <label className="add-withdraw-field">
                        <span>Account number</span>

                        <input
                          type="text"
                          inputMode="numeric"
                          value={accountNumber}
                          onChange={(event) =>
                            setAccountNumber(
                              event.target.value.replace(/\D/g, ""),
                            )
                          }
                          placeholder="Enter account number"
                          className="add-withdraw-input"
                          autoComplete="off"
                        />
                      </label>

                      <label className="add-withdraw-field">
                        <span>Bank name</span>

                        <input
                          type="text"
                          value={bankName}
                          onChange={(event) => setBankName(event.target.value)}
                          placeholder="Enter bank name"
                          className="add-withdraw-input"
                          autoComplete="organization"
                        />
                      </label>

                      <label className="add-withdraw-field">
                        <span>IFSC code</span>

                        <input
                          type="text"
                          value={ifscCode}
                          onChange={(event) =>
                            setIfscCode(
                              event.target.value
                                .toUpperCase()
                                .replace(/\s/g, ""),
                            )
                          }
                          placeholder="Enter IFSC code"
                          className="add-withdraw-input"
                          autoComplete="off"
                        />
                      </label>
                    </div>
                  ) : (
                    <div className="add-withdraw-fields">
                      <label className="add-withdraw-field">
                        <span>Holder name</span>

                        <input
                          type="text"
                          value={upiHolder}
                          onChange={(event) => setUpiHolder(event.target.value)}
                          placeholder="Enter holder name"
                          className="add-withdraw-input"
                          autoComplete="name"
                        />
                      </label>

                      <label className="add-withdraw-field">
                        <span>{showUpiForm} ID or number</span>

                        <input
                          type="text"
                          value={upiId}
                          onChange={(event) => setUpiId(event.target.value)}
                          placeholder={`Enter ${showUpiForm} ID or number`}
                          className="add-withdraw-input"
                          autoComplete="off"
                        />
                      </label>
                    </div>
                  )}

                  <label className="add-withdraw-terms">
                    <input
                      type="checkbox"
                      className="add-withdraw-checkbox"
                      checked={isTermsChecked}
                      onChange={(event) =>
                        setIsTermsChecked(event.target.checked)
                      }
                    />

                    <span>
                      I have read and accept the payment and withdrawal policy.
                    </span>
                  </label>

                  <div className="add-withdraw-modal-actions">
                    <button
                      type="button"
                      className="add-withdraw-cancel-button"
                      onClick={closePaymentMethodModal}
                      disabled={isSavingMethod}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      disabled={isSavingMethod}
                      className="withdraw-submit-button add-withdraw-submit-button"
                    >
                      {isSavingMethod ? "Saving..." : "Add Method"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </section>

        {/* <div className="withdraw-actions add-withdraw-actions">
          <button
            onClick={() => setShowWithdrawHistory(!showWithdrawHistory)}
            className="withdraw-action-button add-withdraw-history-toggle"
          >
            {showWithdrawHistory
              ? "Hide Withdraw Methods"
              : "Show Withdraw Methods"}
          </button>
        </div> */}
        {/* {showWithdrawHistory && (
          <div className="history-section">
            <h3>Previous Methods</h3>
            <div className="history-table-container">
              <Table
                columns={methodColumns}
                className="min-w-full border border-gray-200 rounded-lg"
                dataSource={paymentMethod}
                bordered
                pagination
              />
            </div>
          </div>
        )} */}
        {/* {showWithdrawHistory && (
          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-900">Previous Methods</h3>
            <div className="overflow-x-auto">
              <Table
                columns={methodColumns}
                className="min-w-full border border-gray-200 rounded-lg"
                dataSource={paymentMethod}
                bordered
                pagination
              />
            </div>
          </div>
        )} */}

        <section className="withdraw-saved-methods">
          <header className="withdraw-saved-methods-header">
            <div>
              <h3>Previous Methods</h3>

              <p>
                {paymentMethod.length} saved{" "}
                {paymentMethod.length === 1 ? "method" : "methods"}
              </p>
            </div>

            <button
              type="button"
              className="withdraw-method-visibility-button"
              onClick={() => setShowWithdrawHistory((previous) => !previous)}
            >
              {showWithdrawHistory ? "Hide" : "Show"}
            </button>
          </header>

          {showWithdrawHistory && (
            <div className="withdraw-method-table-wrap">
              <Table
                rowKey={(record) => record._id}
                columns={methodColumns}
                dataSource={paymentMethod}
                size="small"
                pagination={{
                  pageSize: 5,
                  size: "small",
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                  position: ["bottomCenter"],
                }}
                className="withdraw-method-table"
                tableLayout="fixed"
                locale={{
                  emptyText: "No payment methods added yet.",
                }}
              />
            </div>
          )}
        </section>
        {/* <div className="mt-6">
          <div className="bg-white shadow-lg rounded-2xl p-1">
            <h3 className="text-2xl font-bold mb-2 text-gray-900">
              Withdraw History
            </h3>
            <div className="overflow-x-auto">
              <Table
                columns={historyColumns}
                dataSource={withdrawHistory}
                pagination={{ pageSize: 10 }}
                bordered
                rowClassName="hover:bg-gray-50"
                className="rounded-lg overflow-hidden custom-green-header"
                scroll={{ x: "max-content" }}
              />
            </div>
          </div>
        </div> */}
      </main>
    </>
  );
};

export default AddWithdrawMethod;
